import React, { ButtonHTMLAttributes, useEffect } from 'react';
import { useState } from 'react';
import './filter.scss';
import filter from '../../assets/icons/filter.svg';
import circularLoader from '../../assets/icons/grey-activity-circular-loader.svg';
import clsx from 'clsx';
import { MainButton } from '../MainButtons/MainButton';

export interface FilterLinkProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  texte: string;
  color?: 'primary' | 'secondary' | 'white' | string;
  textcolor?: string;
  icon?: string;
  isShow: boolean;
  isFetchingFiltersDate?: boolean;
  isFetchingFiltersName?: boolean;
  handleFromDate: (date: string) => void;
  handleToDate: (date: string) => void;
  handleSearchName: (name: string) => void;
  searchName: string;
  handle?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const BaseFilters = ({
  texte,
  color,
  textcolor,
  icon,
  handle,
  isShow,
  handleFromDate,
  handleToDate,
  handleSearchName,
  isFetchingFiltersDate,
  isFetchingFiltersName,
  searchName,
  ...props
}: FilterLinkProps): JSX.Element => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const [datesValid, setDatesValid] = useState(true);

  useEffect(() => {
    if (fromDate !== '' && toDate !== '') {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      setDatesValid(from < to);
    }
  }, [fromDate, toDate]);

  const today = new Date().toISOString().split('T')[0];

  function changeToDate(date: string) {
    setToDate(date);
    handleToDate(date);
  }

  function changeFromDate(date: string) {
    setFromDate(date);
    handleFromDate(date);
  }

  function changeNameSearch(name: string) {
    handleSearchName(name);
  }

  return (
    <div className="flex ">
      <div className="filters-header">
        <MainButton
          variant="text"
          description={texte}
          disabled
          type="button"
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              className="mr-2"
            >
              <path
                d="M10.5 18H7.5C7.10218 18 6.72064 17.842 6.43934 17.5607C6.15804 17.2794 6 16.8978 6 16.5V10.8075L0.4425 5.25C0.160809 4.96999 0.00167459 4.58968 0 4.1925V1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0H16.5C16.8978 0 17.2794 0.158035 17.5607 0.43934C17.842 0.720644 18 1.10218 18 1.5V4.1925C17.9983 4.58968 17.8392 4.96999 17.5575 5.25L12 10.8075V16.5C12 16.8978 11.842 17.2794 11.5607 17.5607C11.2794 17.842 10.8978 18 10.5 18ZM1.5 1.5V4.1925L7.5 10.1925V16.5H10.5V10.1925L16.5 4.1925V1.5H1.5Z"
                fill="#2277DB"
              />
            </svg>
          }
          position="center"
          className="mx-4 bg-blue-00/10 text-blue-00  "
          onClick={handle}
        />

        {(toDate !== '' || fromDate !== '') && (
          <button
            className="filters-header__clear"
            onClick={() => {
              changeToDate('');
              changeFromDate('');
              setDatesValid(true);
            }}
          >
            <svg
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                  d="M18 7L7 18M7 7L18 18"
                  stroke="#0000FF"
                  strokeWidth="1.2"
                ></path>{' '}
              </g>
            </svg>
            <span>CLEAR FILTERS</span>
          </button>
        )}
      </div>
      {isShow && (
        <div className="filters-infos">
          <div
            className={clsx({
              'filters-infos__top': true,
              'check--valid': !datesValid,
            })}
          >
            <button>
              <span>From : </span>
              <input
                type="date"
                onChange={(e) => {
                  changeFromDate(e.target.value);
                }}
                value={fromDate}
                max={today}
              />
            </button>
            <button>
              <span>to : </span>
              <input
                type="date"
                onChange={(e) => {
                  changeToDate(e.target.value);
                }}
                value={toDate}
                max={today}
              />
            </button>
          </div>
        </div>
      )}
      {(isFetchingFiltersDate || isFetchingFiltersName) && (
        <div className="filters-loading">
          <div className="d-flex flex-row justify-content-center my-3">
            <span className="icon-circular-loader">
              <img src={circularLoader} alt="Loading" className="animation" />
            </span>
            <span className="loader-text">Fetching transactions</span>
          </div>
        </div>
      )}
    </div>
  );
};

export const Filter: React.FC<FilterLinkProps> = ({
  texte,
  color,
  textcolor,
  icon,
  handle,
  isShow,
  ...props
}): JSX.Element => (
  <BaseFilters
    texte={texte}
    textcolor={textcolor}
    color={color}
    icon={icon}
    handle={handle}
    isShow={isShow}
    {...props}
  />
);

Filter.defaultProps = {
  texte: '',
  textcolor: '',
  color: '',
  icon: '',
  isShow: true,
  handle: () => ({}),
};
BaseFilters.defaultProps = Filter.defaultProps;
